import { useCallback } from "react";
import { useRecaptchaContext } from "@shared/contexts/RecaptchaContext";

export function useFormRecaptcha() {
  const { executeRecaptcha, isEnabled: recaptchaEnabled, setCurrentToken } = useRecaptchaContext();

  const handleRecaptchaExecution = useCallback(async () => {
    if (!recaptchaEnabled) return;

    try {
      const result = await executeRecaptcha();
      if (result.success && result.token) {
        setCurrentToken(result.token);
      }
    } catch (error) {
      console.warn("reCaptcha setup failed:", error);
    }
  }, [recaptchaEnabled, executeRecaptcha, setCurrentToken]);

  return { handleRecaptchaExecution };
}
